import React from "react";
import { Flex, Text } from "app/components/common/ui";
import "./animations.css";
import { Button } from "../ui/Button";

export const Error = () => {
  return (
    <Flex
      width="200px"
      height="200px"
      position="fixed"
      top="50%"
      left="50%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      marginLeft={{ _: "-100px", lg: "50px" }}
      marginTop="-100px"
      zIndex={100}
    >
      <svg
        width="81"
        height="87"
        viewBox="0 0 81 87"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="inner-error"
          d="M40.5 16.375C32.2128 16.375 25.4707 23.0339 25.4707 31.2187C25.4707 34.7956 26.7585 38.0809 28.8999 40.6466L31.1021 35.3334C30.5348 34.0748 30.2168 32.6831 30.2168 31.2187C30.2168 25.6186 34.8298 21.0625 40.5 21.0625C46.1702 21.0625 50.7832 25.6186 50.7832 31.2187C50.7832 32.6831 50.4652 34.0747 49.8981 35.3336L52.1002 40.6466C54.2415 38.0809 55.5293 34.7956 55.5293 31.2187C55.5293 23.0339 48.7872 16.375 40.5 16.375Z"
          fill="white"
        />
        <path
          className="outer-error"
          d="M25.0265 49.992L26.9262 45.4087C23.1098 41.8458 20.7246 36.8025 20.7246 31.2188C20.7246 20.4492 29.5958 11.6875 40.5 11.6875C51.4042 11.6875 60.2754 20.4492 60.2754 31.2188C60.2754 36.8023 57.8902 41.8458 54.074 45.4086L55.9737 49.992C61.4913 45.5473 65.0215 38.783 65.0215 31.2188C65.0215 17.8645 54.0213 7 40.5 7C26.9789 7 15.9785 17.8645 15.9785 31.2188C15.9785 38.783 19.5087 45.5473 25.0265 49.992Z"
          fill="white"
        />
        <path
          d="M44.2529 34.0866C44.8749 33.2938 45.2461 32.2994 45.2461 31.2188C45.2461 28.6298 43.1213 26.5312 40.5 26.5312C37.8787 26.5312 35.7539 28.6298 35.7539 31.2188C35.7539 32.2994 36.125 33.2938 36.7471 34.0866L14.8159 87H21.9902L40.5 79.3828L59.0098 87H66.1841L44.2529 34.0866ZM46.1605 51.0625H34.8395L40.5 37.4053L46.1605 51.0625ZM41.6675 55.75L29.8365 63.1331L32.8966 55.75H41.6675ZM48.6068 56.9645L52.6367 66.6875H33.0262L48.6068 56.9645ZM40.5 74.3047L22.0611 81.8927L26.4204 71.375H54.5794L58.9387 81.8927L40.5 74.3047Z"
          fill="white"
        />
        <path
          className="lightning-error"
          d="M40 21V13H34L40 1V9H46L40 21Z"
          fill="#ff5959"
        />
        <path
          className="lightning-error"
          d="M30.8714 26.9719L23.144 24.9014L21.5911 30.6969L11.5529 21.7955L19.2803 23.8661L20.8332 18.0705L30.8714 26.9719Z"
          fill="#ff5959"
        />
        <path
          className="lightning-error"
          d="M51.0986 28.4667L57.9492 24.3352L54.8506 19.1973L68.2251 18.1379L61.3745 22.2695L64.4731 27.4074L51.0986 28.4667Z"
          fill="#ff5959"
        />
      </svg>
      <br />
      <Text color="white">Connection Error</Text>
      <br />
      <Button onClick={() => window.location.reload(false)}>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="white">
          <path
            d="M14.8844 31.9809C11.4781 31.6866 8.37242 30.4429 5.84134 28.3596C1.4218 24.722 -0.719258 19.0209 0.216233 13.3815C0.633864 10.8639 1.68644 8.42166 3.25634 6.3278C3.82775 5.56568 5.15693 4.19696 5.92774 3.57695C7.21947 2.53792 9.01443 1.51906 10.526 0.966886C11.7234 0.529456 13.2712 0.191106 14.6653 0.0619861C18.6747 -0.309344 22.9264 1.00255 26.1237 3.59761C26.8727 4.20547 28.196 5.5727 28.7546 6.31574C30.4157 8.52545 31.4895 11.1109 31.884 13.8505C32.0389 14.9263 32.0386 17.0792 31.8833 18.1657C31.4912 20.9104 30.4373 23.4511 28.7595 25.6961C28.1828 26.4679 26.4776 28.1719 25.7054 28.7483C23.5013 30.3931 21.0218 31.4371 18.3709 31.8364C17.5787 31.9557 15.5604 32.0394 14.8843 31.9809H14.8844ZM17.6379 25.3545C19.3066 25.0722 21.1432 24.1763 22.3809 23.041C23.0555 22.4223 23.2273 21.9986 23.0482 21.3958C22.8767 20.8186 22.3668 20.4484 21.7434 20.4484C21.3953 20.4484 21.1306 20.5872 20.6045 21.0458C19.3338 22.1532 17.9371 22.7271 16.3189 22.8066C11.2336 23.0567 7.67267 17.7431 9.84613 13.148C10.5131 11.7378 11.6098 10.6094 12.9756 9.92781C15.213 8.81136 17.8374 9.006 19.917 10.4426C20.4522 10.8124 21.3184 11.6871 21.6562 12.1989C21.931 12.6153 22.3539 13.4425 22.3129 13.4835C22.297 13.4994 21.8175 13.2719 21.2475 12.9779C20.102 12.3872 19.858 12.3332 19.3584 12.56C19.0891 12.6823 18.7301 13.0489 18.6351 13.2987C18.4732 13.724 18.6353 14.4401 18.9613 14.7396C19.0443 14.8158 20.1675 15.4279 21.4572 16.0997C23.6808 17.2579 23.82 17.3211 24.1464 17.3199C24.5594 17.3185 24.9354 17.1615 25.1573 16.898C25.2929 16.737 26.7132 14.0702 27.4874 12.5231C27.9131 11.6726 27.7284 10.9339 26.9939 10.5489C26.5057 10.293 25.7881 10.42 25.4227 10.8269C25.3502 10.9077 25.1551 11.234 24.9892 11.5521L24.6876 12.1305L24.3947 11.5765C22.2234 7.46845 17.3952 5.5386 12.9808 7.01426C10.6656 7.78823 8.63811 9.55265 7.52966 11.7582C6.85221 13.1062 6.53978 14.4373 6.53952 15.9768C6.53933 17.1775 6.65347 17.9113 7.00603 18.9758C7.48439 20.4201 8.21737 21.6018 9.31533 22.6991C10.933 24.3156 12.7847 25.1808 15.2599 25.4767C15.6706 25.5258 17.042 25.4553 17.6379 25.3545V25.3545Z"
            fill="white"
          />
        </svg>
      </Button>
    </Flex>
  );
};
